<template>
  <b-navbar
    toggleable="lg"
    type="light"
    :fixed="!getActiveTour ? 'top' : ''"
    variant="white"
    :class="['main-navbar', stagingColor]"
  >
    <b-navbar-brand
      v-if="showLogo"
      :to="homeRoute"
      class="p-3"
      v-track-click
      id="header-logo"
    >
      <img
        src="@/assets/images/common/logo-dark.svg"
        alt="Error Icon"
        height="40"
      />
    </b-navbar-brand>
    <div class="m-buttons">
      <b-button
        variant="primary"
        class="d-block d-md-none"
        v-track-click
        id="nav-add-invoice-mobile"
        @click="newInvoiceRedirectMethod"
        v-if="hasPermission && isActive"
        :disabled="firstTourStatus || ddpCheck"
      >
        <img src="@/assets/images/common/plus.svg" />
      </b-button>
      <b-navbar-toggle target="nav-collapse" class="toggler"></b-navbar-toggle>
    </div>
    <b-collapse is-nav id="nav-collapse">
      <primary-header
        class="d-print-none"
        v-if="account && account.role === 'exporters' && isActive"
        :isDisabled="firstTourStatus"
        :enableInsights="isIndian"
        :isIndian="isIndian"
      />
      <b-navbar-nav class="ml-auto right right-header">
        <img
          v-if="
            ['dashboard'].indexOf($route.name) > -1 &&
            $store.state.account.country === 'India' &&
            isActive
          "
          v-track-click
          class="info-icon d-none d-md-block"
          src="@/assets/images/header/info.svg"
          alt="Info Icon"
          height="38"
          id="v-step-11"
          :class="activeTour === 1 && 'zindex'"
          @click="tourHandler"
        />
        <b-nav-item
          v-track-click
          :class="activeTour === 3 && 'zindex'"
          class="d-none d-inline d-md-block"
          id="nav-add-invoice"
          @click="newInvoiceRedirectMethod"
          v-if="hasPermission && !isImporter && isActive"
          :disabled="firstTourStatus || ddpCheck"
          exact
        >
          <b-button
            v-if="!ddpCheck"
            variant="primary"
            :disabled="enableAddInvoice"
            block
            id="v-step-13"
            class="add-new-invoice"
          >
            {{ $t('menu.createInvoice') }}
          </b-button>
          <span
            v-if="ddpCheck"
            class="d-inline-block"
            tabindex="0"
            v-b-tooltip.hover
            :title="`Your Dynamic Drawing Power (DDP) has been reduced to Zero. Please reach out to ${name} - ${email} for more information.`"
            :disabled="!ddpCheck"
          >
            <b-button
              variant="primary"
              :disabled="firstTourStatus || ddpCheck"
              block
              class="add-new-invoice"
            >
              {{ $t('menu.createInvoice') }}
            </b-button>
          </span>
        </b-nav-item>
        <b-nav-item-dropdown
          right
          id="header-account-dropdown"
          class="account-dropdown ml-3 ml-md-0"
          v-if="
            $store.getters.user &&
            $store.getters.user.linked_users &&
            $store.getters.user.linked_users.length > 1
          "
        >
          <template slot="button-content">
            {{ accountCompany }}
          </template>
          <b-dropdown-item
            v-track-link
            :id="`header-account-select-${account && account.id}`"
            v-for="account in $store.getters.user.linked_users"
            :key="account && account.id"
            @click="setAccount(account, true)"
          >
            {{ account.company }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- // hiding this for the time being until mexico translations are done properly -->
        <lang-mx v-if="$store.state.account.country === 'Mexico'" />
        <b-nav-item-dropdown
          right
          id="header-user-dropdown"
          class="ml-3 ml-md-0 mr-2"
        >
          <template slot="button-content">
            {{ $store.getters.user && $store.getters.user.name }}
          </template>
          <b-dropdown-item
            v-if="!isImporter && isActive"
            :to="{ name: 'account' }"
            v-track-link
            id="sidebar-account"
          >
            <b-icon-person class="wealthy-green-color-fill" />
            <span class="icon">{{ $t('menu.account') }}</span>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="!isImporter && isIndian && isActive"
            :to="{ name: 'currencySettings' }"
            v-track-link
            id="sidebar-currency-settings"
          >
            <b-icon-gear class="wealthy-green-color-fill" />
            <span class="icon">{{ $t('menu.currencySettings') }}</span>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="!isMx && !isImporter && isActive"
            :to="{ name: 'bankAccounts' }"
            v-track-link
            id="sidebar-bank-accounts"
          >
            <b-img
              :src="require('@/assets/images/common/bank-accounts-icon.svg')"
              class="text-center"
            ></b-img>
            <span class="icon">{{ $t('menu.bankAccounts') }}</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click.prevent="logout"
            v-track-link
            id="header-signout"
          >
            <b-img
              :src="require('@/assets/images/common/sign-out.svg')"
              class="text-center"
            ></b-img>
            <span class="icon">{{ $t('menu.signOut') }}</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { configureScope } from '@sentry/vue'
import Cookies from 'js-cookie'
import exportersService from '@/services/exporters'
import LangMx from '@/components/header/LangMx'
import PrimaryHeader from '@/components/PrimaryHeader'
import mouseflow from '@/utils/mouseflow'
import { freshdeskMixin } from '@/mixins/Freshdesk'
import accountsService from '@/services/accounts'
import monitoringService from '@/services/monitoring'

export default {
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  },
  props: {
    showLogo: {
      type: Boolean,
      default: false
    },
    firstTourStatus: {
      type: Boolean,
      default: false
    },
    enableAddInvoice: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: '',
      email: '',
      countryLocale: {
        Mexico: 'es',
        India: 'en'
      },
      monitoringData: null
    }
  },
  created() {
    if (!this.$store.getters.user) {
      this.logout()
    }
  },
  mounted() {
    this.fetchMonitoringData(false)
    this.checkRequest()
    this.setLocale()
    this.setSentryAccount()
    this.legalCheckAndPopUps()
  },
  methods: {
    legalCheckAndPopUps() {
      if (!this.isImporter) {
        const isStatusApproved =
          this.$store.state.account &&
          this.$store.state.account.account &&
          this.$store.state.account.account.status === 'approved'

        const isLegalAgreementNotSigned = !(
          this.$store.state.account &&
          this.$store.state.account.account &&
          this.$store.state.account.account.legal_agreements_esigned
        )

        const pathsToIgnore = !['generateLegal', 'legalEsign'].includes(
          this.$route.name
        )

        if (
          this.isIndian &&
          isStatusApproved &&
          isLegalAgreementNotSigned &&
          pathsToIgnore
        ) {
          this.$router.push('/legal-sign/').catch((_) => 1)
          return
        }

        this.getUserConfig()
      }
    },
    getUserConfig() {
      accountsService
        .getExporterAccountData(
          (this.$store.state.account && this.$store.state.account.accountId) ||
            ''
        )
        .then((res) => {
          this.$store.dispatch(
            'setDripSwitchUserLevel',
            res.data.drip_switch_enabled
          )
          this.$store.dispatch('setTotalTransactionsConfig', {
            isInrTransactionCompleted:
              res.data.total_drip_switch_transactions > 0
          })
        })
        .catch()
    },
    checkRequest() {
      const userId = this.getParamsUserId()

      // When admin wants to sign-in/impersonate as user log-in.
      // and also removes the query params from website url
      if (userId && typeof parseInt(userId) === 'number') {
        this.setAccount(this.findExporter(userId), false)
        this.$router.push(location.href.replace(location.origin, ''))
        return
      }
      // if the user logs in for the first time
      if (!this.$store.state.account.accountId) {
        this.setAccount(
          this.$store.getters.user &&
            this.$store.getters.user.linked_users &&
            this.$store.getters.user.linked_users[0]
        )
        return
      }
      // when a user refreshes page
      if (this.$store.state.account && this.$store.state.account.accountId) {
        this.setAccount(this.findExporter(this.$store.state.account.accountId))
      }
    },
    invoiceGuide() {
      this.$emit('firstTourStatusChanged', true)
      this.$emit('enableAddInvoiceChanged', true)
    },
    newUserCoachmarks() {
      if (
        ['dashboard'].indexOf(this.$route.name) > -1 &&
        this.hasPermission &&
        this.$store.state.account.accountId
      ) {
        return exportersService
          .fetchExporterMetaData(this.$store.state.account.accountId, {
            include: ['analytics', 'relationship_manager']
          })
          .then((res) => {
            if (res.data.analytics.invoices_total === 0) {
              if (this.isIndian) {
                this.tourHandler()
              }
            }
            this.name =
              res.data.relationship_manager &&
              res.data.relationship_manager.name
            this.email =
              res.data.relationship_manager &&
              res.data.relationship_manager.email
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    setSentryAccount() {
      const user = this.$store.getters.user
      if (user) {
        user.currentAccount = this.account // this will be used in mixpanel also
        configureScope((scope) => {
          scope.setUser(user)
          scope.setTag(
            'mfSessionId',
            window?.mouseflow?.getSessionId() || 'N/A'
          )
        })
      }
    },
    setAccount(account, redirect = false) {
      if (this.isDebtorSCF(account)) {
        this.setCookie(account)
        this.redirectToSCF()
        return
      }
      if (account && account.id !== this.$store.state.account.accountId) {
        this.$store.dispatch('setAccountId', {
          id: account.id
        })
        this.$store.dispatch('setAccount', {
          account: account
        })
        // set validator locale
        this.$validator.localize(this.countryLocale[`${account.country}`])

        mouseflow.SET_USER_DATA({
          id: this.$store.getters.user && this.$store.getters.user.id,
          name: this.$store.getters.user && this.$store.getters.user.name,
          business_id:
            this.$store.state.account && this.$store.state.account.accountId
        })

        this.navigate(account, redirect)

        if (account && account.role === 'exporters') {
          this.newUserCoachmarks()
        }
      }
      // this.findExporter(id).parent_user_permissions['aadhar_esign_allowed?'])
    },
    navigate(account, redirect) {
      this.setLocale()
      this.$mpTrack('Country Set', {
        country: account.country
      })

      if (account.country === 'Mexico') {
        this.$store.dispatch('setLocale', 'es-MX')
        this.hideFreshdeskWidget()
      } else {
        this.$store.dispatch('unsetLocale')
      }

      if (redirect) {
        if (account && account.role === 'importers') {
          this.$router.push({ name: 'importerDashboard' }).catch((_) => 1)
        } else if (account && account.role === 'exporters') {
          if (
            account.status === 'approved' &&
            !account.legal_agreements_esigned
          ) {
            this.$router.push('/legal-sign/').catch((_) => 1)
            return
          }
          if (window.location.pathname) {
            this.$router.push(window.location.pathname).catch((_) => 1)
          } else {
            this.$router.push({ name: 'dashboard' }).catch((_) => 1)
          }
        }
      }
    },
    findExporter(exporterId) {
      if (this.$store.getters.user) {
        return this.$store.getters.user.linked_users.find((exporter) => {
          return parseInt(exporter.id) === parseInt(exporterId)
        })
      }
      return {}
    },
    logout() {
      this.$router.push('/logout')
    },
    setLocale() {
      this.$i18n.locale = this.$store.state.account.currentLocale
      document.documentElement?.setAttribute('lang', this.$i18n.locale)
    },
    tourHandler() {
      if (this.activeTour === 0) {
        this.invoiceGuide()
        this.$store.dispatch('setTourState', true)
        this.$tours['portal-guide'].start()
      }
    },
    setCookie(account) {
      const token =
        Cookies.get('default_auth_token') || this.$store.getters.token
      Cookies.set('default_auth_token', token, {
        domain: '.dripcapital.com'
      })
      Cookies.set('user_id', account.link_id, { domain: '.dripcapital.com' })
    },
    redirectToSCF() {
      const callback = this.$route.query.callback
      const application = this.$route.query.app
      const redirectUrl =
        process.env.VUE_APP_DRIP_SCF_PORTAL_HOST +
        (application === 'PSCF' ? callback : '')

      window.location.href = redirectUrl
    },
    isDebtorSCF(account) {
      return account && account.debtor_type === 'scf'
    },
    getParamsUserId() {
      const userId = this.$route.query.user_id

      return userId || ''
    },
    async newInvoiceRedirectMethod() {
      await this.fetchMonitoringData(true)
      if (
        !!this.monitoringData &&
        !!this.monitoringData?.mail_date &&
        this.$moment(this.monitoringData?.revoke_date).isValid() &&
        this.$moment(this.monitoringData?.mail_date).isValid() &&
        (this.monitoringData?.financials.active ||
          this.monitoringData?.gst.active)
      ) {
        const mailDate = new Date(this.monitoringData?.mail_date) // Convert to Date object
        const currentDate = new Date() // Get today's date

        // Calculate the date 60 days after the mail_date
        const days60AfterMailDate = new Date(mailDate)
        days60AfterMailDate.setDate(mailDate.getDate() + 60)

        if (currentDate >= new Date(this.monitoringData?.revoke_date)) {
          this.$mpTrack('Header - Redirected to accounts page', {
            revoke_date: this.monitoringData?.revoke_date
          })
          this.$router.push({ name: 'account' })
        } else {
          this.$mpTrack('Header - Redirected to add invoice page')
          this.$router.push({ name: 'invoicesAdd' })
        }
      } else {
        this.$mpTrack('Header - Redirected to add invoice page')
        this.$router.push({ name: 'invoicesAdd' })
      }
    },
    async fetchMonitoringData(loadingSkip) {
      if (!loadingSkip) {
        this.loading = true
      }
      try {
        if (this.$store.getters.accountId) {
          const res = await monitoringService.getMonitoringData(
            this.$store.getters.accountId
          )
          this.monitoringData = res.data
        }
      } catch (error) {
        console.error('Error fetching monitoring data:', error)
        // Optionally set an error message to display to the user
        this.errorMessage = 'Failed to fetch monitoring data. Please try again.'
      } finally {
        this.loading = false // Ensure loading is set to false regardless of success or error
      }
    }
  },
  computed: {
    account() {
      if (this.$store.getters.user && this.$store.getters.user.linked_users) {
        return this.findExporter(this.$store.state.account.accountId) || {}
      }
      return {}
    },
    accountCompany() {
      return this.account &&
        this.account.company &&
        this.account.company.length > 20
        ? this.account.company.slice(0, 20).concat('...')
        : this.account.company
    },
    homeRoute() {
      return this.account && this.account.role === 'importers'
        ? { name: 'importerDashboard' }
        : { name: 'dashboard' }
    },
    hasPermission() {
      return this.$store.getters.hasInvoiceAddAndCreatePermission()
      /**
        * ?: below is the old code.
        return (
          this.$store.getters.hasPermission('esign') ||
          this.$store.getters.hasPermission('edit')
        )
       **/
    },
    ddpCheck() {
      return this.$store.getters.ddpCheck === 0
    },
    stagingColor() {
      return process.env.VUE_APP_ENVIRONMENT === 'staging'
        ? 'pending-color'
        : null
    },
    isIndian() {
      return this.$store.state.account.country === 'India'
    },
    isImporter() {
      return this.account && this.account.role === 'importers'
    },
    isMx() {
      return this.$i18n.locale === 'es-MX' || this.$i18n.locale === 'en-MX'
    },
    ...mapState({
      activeTour: (state) => state.root.activeTour
    }),
    ...mapGetters(['getActiveTour'])
  },
  mixins: [freshdeskMixin],
  components: {
    LangMx,
    PrimaryHeader
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables';
.wealthy-green-color-fill {
  fill: $wealthy-green-500;
}
.icon {
  margin-left: 16px;
}
.main-navbar {
  border-bottom: 1px solid $gray-300;
  margin-bottom: 20px;
  padding: 0;
  max-height: 70px;
  #nav-add-invoice {
    a {
      padding: 15px 0 !important;
    }
  }
  .nav-link {
    padding: 1.5rem 1rem !important;
  }
  .right-header {
    align-items: center;
  }
}
.main-navbar:not(.fixed-top) {
  top: 0;
  left: 0;
  right: 0;
}
.pending-color {
  background-color: $pending-color !important;
}
.zindex {
  z-index: 2;
}
@include media-breakpoint-down(md) {
  .toggler {
    margin-right: 1rem;
  }
  .main-navbar {
    #nav-collapse {
      z-index: 1;
      background: white;
      border-bottom: 1px solid #dee2e6;
      .nav-link {
        padding: 1rem !important;
      }
    }
    .right-header {
      align-items: normal;
    }
  }
  .m-buttons {
    display: flex;
    > a {
      margin-right: 1rem;
    }
  }
}
.add-new-invoice {
  @media screen and (max-width: 1124px) {
    font-size: 13px;
    padding: 12px 8px;
  }
}
.info-icon {
  cursor: pointer;
  margin: 0.7rem;
}
</style>
